// extracted by mini-css-extract-plugin
export default {"ComplementaryResults":"_0wsnAD32Sr6Xes9jeKF"};